import React from "react";
import { motion } from "framer-motion";

export type BillingCycle = "monthly" | "yearly";

interface BillingToggleProps {
  cycle: BillingCycle;
  setCycle: (cycle: BillingCycle) => void;
}

export function BillingToggle({ cycle, setCycle }: BillingToggleProps) {
  return (
    <div className="flex justify-center mb-[30px] relative z-20">
      {/* Sticky wrapper can be in parent, or here if we use sticky on this div */}
      <div className="relative inline-flex items-center p-1.5 rounded-full bg-white border border-[#E2E8F0] shadow-sm h-[52px]">
        {/* Monthly Button */}
        <button
          onClick={() => setCycle("monthly")}
          className={`relative z-10 w-[120px] h-full rounded-full text-sm font-medium transition-colors duration-300 flex items-center justify-center ${cycle === "monthly" ? "text-white" : "text-[#475569] hover:text-[#0F172A]"
            }`}
        >
          {cycle === "monthly" && (
            <motion.div
              layoutId="active-pill"
              className="absolute inset-0 bg-[#0F172A] rounded-full shadow-sm z-[-1]"
              transition={{ type: "spring", stiffness: 400, damping: 30 }}
            />
          )}
          Monthly
        </button>

        {/* Yearly Button */}
        <button
          onClick={() => setCycle("yearly")}
          className={`relative z-10 w-[120px] h-full rounded-full text-sm font-medium transition-colors duration-300 flex flex-col items-center justify-center leading-tight ${cycle === "yearly" ? "text-white" : "text-[#475569] hover:text-[#0F172A]"
            }`}
        >
          {cycle === "yearly" && (
            <motion.div
              layoutId="active-pill"
              className="absolute inset-0 bg-[#0F172A] rounded-full shadow-sm z-[-1]"
              transition={{ type: "spring", stiffness: 400, damping: 30 }}
            />
          )}
          <span>Yearly</span>
          <span
            className={`text-[9px] uppercase tracking-wider font-bold transition-colors mt-0.5 ${cycle === "yearly" ? "text-white/80" : "text-[#10B981]"
              }`}
          >
            Save 20%
          </span>
        </button>
      </div>
    </div>
  );
}
